module.exports = __webpack_public_path__ + "img/logo.72105256.png";